import React, { useState } from "react";
import { Grid } from "@mui/material";
import KeywordSearch from "../../../common/SearchComponent/KeywordSearch";
import ConservationTable from "./ConservationTable";
import DownloadReport from "./DownloadReport";
import { handleDownload } from "../../../common/DownloadExcelReports/DownloadExcelReports";
import ReportFilters from "./ReportFilter";

export default function ConservationSearch({ tabIndex }) {
  const [querySearch, setQuerySearch] = useState("");
  const [museumId, setMuseumId] = useState("");

  const handleSearchChange = (value) => {
    setQuerySearch(value);
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item sm={3} xs={3}>
          <KeywordSearch placeholder={"Search..."} onChange={(value) => handleSearchChange(value)} />
        </Grid>
        <Grid item xs={9}>
          <ReportFilters setMuseumId={setMuseumId} />
        </Grid>
      </Grid>
      <DownloadReport handleDownload={() => handleDownload(tabIndex)} />
      <ConservationTable querySearch={querySearch} museumId={museumId} />
    </div>
  );
}
